"use client";

import React from "react";
import { ButtonStyleType, SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";
import { Badge } from "../ui/badge";

interface Feature18Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  removePaddingBottom?: boolean;
  themeChangeOnScroll?: boolean;
  badge?: string;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  microCopy?: string;
  secondaryButton?: boolean;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  secondaryButtonStyle?: ButtonStyleType;
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature18 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 18",
  removePaddingBottom = false,
  themeChangeOnScroll = false,
  badge,
  title,
  content,
  hasButton,
  buttonText,
  buttonLink,
  buttonStyle,
  microCopy,
  secondaryButton,
  secondaryButtonText,
  secondaryButtonLink,
  secondaryButtonStyle,
  attributes,
}: Feature18Props) => {

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      removePaddingBottom={removePaddingBottom}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature18"
      attributes={attributes}
    >

      <div className="container">
        <div className="flex flex-col justify-between gap-6 lg:flex-row" data-aos="fade-up">
          {title && (
            <div className="lg:w-1/2 text-center lg:text-left">
              {badge && (
                <Badge variant="outline" bold className="mb-6">
                  {badge}
                </Badge>
              )}
              <h3>
                {parse(title)}
              </h3>
            </div>
          )}
          {(content || hasButton) && (
            <div className="lg:w-1/2 flex flex-col gap-6 text-center lg:text-left">
              {content && (
                <div className="text-muted-foreground">
                  {parse(content)}
                </div>
              )}
              {hasButton && (
                <div className="flex flex-col md:flex-row gap-4 justify-center lg:justify-start">
                  <div className="flex flex-col">
                    <Button asChild variant={buttonStyle} size="lg" className="w-full sm:w-auto">
                      <Link href={buttonLink ?? ""}>
                        {buttonText}
                      </Link>
                    </Button>
                    {microCopy && (
                      <p className="paragraph-sm text-muted-foreground text-center lg:text-left mt-3">
                        {microCopy}
                      </p>
                    )}
                  </div>
                  {secondaryButton && (
                    <Button asChild variant={secondaryButtonStyle} size="lg" className="w-full sm:w-auto">
                      <Link href={secondaryButtonLink ?? ""}>
                        {secondaryButtonText}
                      </Link>
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </SectionWrapper>
  )
};

export { Feature18 };